import { render, staticRenderFns } from "./AdvancedLearning.vue?vue&type=template&id=f0be3bd8&scoped=true"
import script from "./AdvancedLearning.vue?vue&type=script&lang=js"
export * from "./AdvancedLearning.vue?vue&type=script&lang=js"
import style0 from "./AdvancedLearning.vue?vue&type=style&index=0&id=f0be3bd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0be3bd8",
  null
  
)

export default component.exports